import { render, staticRenderFns } from "./testingpage.vue?vue&type=template&id=18342cb0&scoped=true&"
import script from "./testingpage.vue?vue&type=script&lang=js&"
export * from "./testingpage.vue?vue&type=script&lang=js&"
import style0 from "./testingpage.vue?vue&type=style&index=0&id=18342cb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18342cb0",
  null
  
)

export default component.exports